import { abtestActivate } from 'JIX/abtest/api.js';
import { compareResponsiveBreakpoint } from 'JIX/utils/breakpoints.js';

export default class Ratings {
    constructor(options) {
        this.container = options.container || document.body;
        this.activated = {};
        this.observer ||= new IntersectionObserver((entries, observer) => {
            for (const entry of entries) {
                if (entry.isIntersecting) {
                    this._activateAbtest(entry.target);
                    observer.unobserve(entry.target);
                }
            }
        }, { threshold: 1, root: null });

        this.handleReload();
    }

    handleReload(jobadWrapper) {
        this.observer.disconnect();
        const container = jobadWrapper ?? this.container;
        container.querySelectorAll('.jix-toolbar__rating').forEach((ratingElem) => {
            this.observer.observe(ratingElem);
        });
    }

    _activateAbtest(elem) {
        const abtestid = elem.dataset.abtestid;
        if (!abtestid || this.activated[abtestid]) {
            return;
        }
        this.activated[abtestid] = true;

        const context = compareResponsiveBreakpoint('md') <= 0 ? 'mobile' : 'desktop';
        abtestActivate(abtestid, context);
    }
}
